const faq = `
<ul>
<li><NavLink exact to="/doc/faq#format">Format</NavLink></li>
<ul>
  <li><NavLink exact to="/doc/faq#what-is-the-id-of-an-object">What is the ID of an object?</NavLink></li>
  <li><NavLink exact to="/doc/faq#what-is-the-entry_id">What is the entry_id?</NavLink></li>
  <li><NavLink exact to="/doc/faq#what-is-the-entry_id">Why is there an entry_id? </NavLink></li>
  <li><NavLink exact to="/doc/faq#what-is-the-difference-between-entry_id-and-urn-how-can-an-item-be-uniquely-identified">What is the difference between entry_id and urn? How can an item be uniquely identified?</NavLink></li>
  <li><NavLink exact to="/doc/faq#how-do-i-recognise-updates-and-versioning-how-should-i-process-them">How can I tell if I have received an item before or not?</NavLink></li>
  <li><NavLink exact to="/doc/faq#how-do-i-recognise-updates-and-versioning-how-should-i-process-them">How do I recognise updates and how should I process them?</NavLink></li>
  <li><NavLink exact to="/doc/faq#what-is-the-version_created">What is the version_created?</NavLink></li>
  <li><NavLink exact to="/doc/faq#how-do-i-recognise-updates-and-versioning-how-should-i-process-them">How can I recognise versioning?</NavLink></li>
  <li><NavLink exact to="/doc/faq#how-do-i-find-the-latest-version-of-a-topicle">How do I find the latest version of a topicle?</NavLink></li>
  <li><NavLink exact to="/doc/faq#how-can-the-latest-versions-of-topicles-be-selected-using-sql">How can the latest versions of topicles be selected using SQL?</NavLink></li>
  <li><NavLink exact to="/doc/faq#isnt-it-enough-to-determine-changes-per-urn-using-version-and-version_created">Isn't it enough to determine changes per urn using version and version_created?</NavLink></li>
  <li><NavLink exact to="/doc/faq#what-is-the-difference-between-updated-and-version_created">What is the difference between updated and version_created?</NavLink></li>
  <li><NavLink exact to="/doc/faq#what-image-sizes-do-the-dpa-feeds-offer-can-i-also-request-two-image-sizes">What image sizes do the dpa feeds offer? Can I also request two image sizes?</NavLink></li>
  <li><NavLink exact to="/doc/faq#how-can-i-select-the-image-sizes-from-the-entry">How can I select the image sizes from the entry?</NavLink></li>
</ul>
<li><NavLink exact to="/doc/faq#apis">APIs</NavLink></li>
<ul>
  <li><NavLink exact to="/doc/faq#for-which-scenario-is-which-of-the-three-interfaces-best-suited">For which scenario is which of the three interfaces best suited?</NavLink></li>
  <li><NavLink exact to="/doc/faq#for-which-scenario-is-which-of-the-three-interfaces-best-suited">What is the specific difference between s3push, wireQ and jsonfeed delivery?</NavLink></li>
  <li><NavLink exact to="/doc/faq#for-which-scenario-is-which-of-the-three-interfaces-best-suited">What are the advantages and disadvantages of the three interfaces?</NavLink></li>
  <li><NavLink exact to="/doc/faq#i-have-been-using-the-jsonfeed-api-so-far-why-should-i-migrate-to-the-wireq-api">I have been using the jsonfeed API so far, why should I migrate to the wireQ API?</NavLink></li>
  <li><NavLink exact to="/doc/faq#how-can-i-perform-a-format-conversion-without-deploying-new-software-locally">How can I perform a format conversion without deploying new software locally?</NavLink></li>
  <li><NavLink exact to="/doc/faq#what-is-the-average-amount-of-data">What is the average amount of data?</NavLink></li>
  <li><NavLink exact to="/doc/faq#i-get-an-authentication-error-when-retrieving-the-wireq-api-what-am-i-doing-wrong">I get an authentication error when retrieving the wireQ-API. What am I doing wrong?</NavLink></li>
</ul>
<li><NavLink exact to="/doc/faq#import-into-cms">Import into CMS</NavLink></li>
<ul>
  <li><NavLink exact to="/doc/faq#how-often-should-the-wireq-api-or-the-jsonfeed-api-be-polled">How often should the wireQ API or the jsonfeed API be polled?</NavLink></li>
  <li><NavLink exact to="/doc/faq#how-should-the-jsonfeed-api-be-retrieved">How should the jsonfeed API be retrieved?</NavLink></li>
  <li><NavLink exact to="/doc/faq#how-often-can-i-request-an-api-and-what-data-load-does-this-generate">How often can I request an API and what data load does this generate?</NavLink></li>
  <li><NavLink exact to="/doc/faq#how-do-i-recognise-blocking-periods-and-how-should-i-process-them">How do I recognise blocking periods and how should I process them?</NavLink></li>
  <li><NavLink exact to="/doc/faq#how-do-i-recognise-withdrawals-and-how-should-i-process-them">How do I recognise withdrawals and how should I process them?</NavLink></li>
  <li><NavLink exact to="/doc/faq#how-should-i-process-the-values-usable-withheld-and-canceled-for-the-publication-status">How should I process the values "usable", "withheld" and "canceled" for the publication status?</NavLink></li>
  <li><NavLink exact to="/doc/faq#according-to-the-documentation-the-value-embargoed-represents-a-blocking-period-it-is-not-clear-to-me-what-this-means-for-dealing-with-the-articles-so-far-the-value-has-always-been-zero-in-my-examples">According to the documentation, the value "embargoed" represents a blocking period. It is not clear to me what this means for dealing with the articles. So far, the value has always been zero in my examples.</NavLink></li>
  <li><NavLink exact to="/doc/faq#what-do-i-have-to-do-to-display-the-web-components-on-my-website">What do I have to do to display the Web Components on my website?</NavLink></li>
</ul>
<li><NavLink exact to="/doc/faq#general">General</NavLink></li>
<ul>
  <li><NavLink exact to="/doc/faq#how-can-i-implement-special-routing-functionality-without-making-major-changes-to-my-cms">How can I implement special routing functionality without making major changes to my CMS?</NavLink></li>
  <li><NavLink exact to="/doc/faq#what-can-i-do-if-i-want-to-use-s3push-with-webhook-but-my-cms-is-behind-a-firewall">What can I do if I want to use s3push with webhook, but my CMS is behind a firewall?</NavLink></li>
  <li><NavLink exact to="/doc/faq#which-address-information-do-the-dpa-feeds-provide">Which address information do the dpa feeds provide?</NavLink></li>
</ul>
</ul>

### Format

#### What is the ID of an object?

The unique ID of a topicle is called **urn**.

#### What is the **entry_id**?

The **entry_id** is used to identify exactly the same entries.
It is a hash of the topicle. For a content-based identification, please use the attribute **urn**.
The **entry_id** can help if you want to determine whether the same entry has already been sent.

#### What is the difference between **entry_id** and **urn**? How can an item be uniquely identified?

Both **entry_id** and **urn** are IDs, but differ in their purpose.
- The **urn**, i.e. the <a href='https://en.wikipedia.org/wiki/Uniform_Resource_Name' target='_blank'>Uniform Resource Name</a> is the stable semantic ID of the main object of the topicle.
- The **entry_id** is a low level ID that is only relevant for technical transmission. In concrete terms, this means that they can use the **entry_id** to check whether they have received exactly this topicle before. This can occur in exceptional cases, for example, due to the asynchronous and distributed backend that generates the dpa-digitalwires.

Topicles with different **urn** are different objects in the dpa editorial system,
even if they may have very similar texts. Webline reports, for example, are
usually based on articels from the Textfunk, but have a different **urn**,
among other things because the text has been changed or text/image links have been added.

For Textfunk and Bildfunk, this is the **URN** of the respective text or image.
For Featuredienst and Webline articles, this is the **URN** of the text.

#### How do I recognise updates and versioning? How should I process them?

The **URN** of an entry remains constant and can be used to check for a previous
reception of this article. Updates can be detected by comparing against the **URN**
and the sorted values of **version**, **version_created** and **updated**.
(see <NavLink exact to="/doc/faq#how-do-i-find-the-latest-version-of-a-topicle">How do I find the latest version of a topicle?</NavLink>)

#### What is the **version_created**?

The key **version_created** is the timestamp of the last version of the underlying main article.

#### How do I find the latest version of a topicle?

In most cases, only the latest version of a post is of interest in the context of current news.

The content of a contribution is identified by the attribute **urn**.
The latest version results from the attributes **version**, **version_created** and **updated**.

* The attribute **version** increases (monotonically) when a content-relevant update is made.
* **version_created** indicates the time when the update was created. In certain cases **version_created** may change while version remains the same.
* **updated** records all changes in the transmitted topicle structure. Changes to associations, such as images of an article, or even just to validity timestamps of links to image resources are reflected in a change to **updated**.

The basic procedure for determining the latest versions of the topicles received via digitalwires APIs is therefore:
* group by **urn**
* sort descending by_
  * **version**
  * **version_created**
  * **updated**
* the first item in each group is the newest topicle

#### How can the latest versions of topicles be selected using SQL?

\`\`\`
SELECT 
  urn, headline, version_created,
  rank() OVER (PARTITION BY urn 
               ORDER BY version DESC, 
                        version_created DESC, 
                        updated DESC) AS rnk
FROM received_entries
where rnk = 1
ORDER BY version_created DESC
\`\`\` 

#### Isn't it enough to determine changes per urn using **version** and **version_created**?

For many practical needs, this is sufficient. Usually articles are resent in
the dpa editorial office (i.e. version increases) if relevant changes are made
even to the metadata of associations (such as images).

If it is important not to miss even the smallest change, it is advisable to take
**updated** into account.

However, more technical changes, such as a new signature of an image link (because
the old one has expired), are also included in the change detection. Depending on
the application, this can be desirable (and e.g. lead to a new import of the image)
or superfluous. 

#### What is the difference between **updated** and **version_created**?

Similar to **entry_id** and **urn**, the two timestamps **updated** and **version_created** are also used. 

- **updated** is a low level timestamp indicating when the topicle was last updated, while **version_created** maps when the last semantically relevant version of the topicle's main object was created.
- While **updated** only has technical relevance and is therefore always indicated in ISO8601 "zulu time", the **version_created** may also be editorially relevant and is displayed on article pages etc.. Therefore, it is displayed there in ISO8601 with time zone information. In this way, it can also be transmitted whether it is summer or winter time. The time information for dpa content is always in the time zone of Berlin. 

#### What image sizes do the dpa feeds offer? Can I also request two image sizes?

As standard, we deliver images with a longest edge of \`2048\`. On request, we
are also happy to provide multiple, customised image formats that are delivered
directly with the dpa-digitalwires format. Linked media objects are transported
as a list of **associations**.
The list of **renditions** within a linked media object describes the respective
sizes of the image and the **url** under which the object can be accessed.

For illustration purposes, a small excerpt from the dpa-digitalwires format:

\`\`\`
"associations": [
{
  "type": "image", 
  "urn": "urn:newsml:dpa.com:20090101:...", 
  "version": 2,
  "is_featureimage": true,
  "rank": 1,
  "headline": "...", 
  "caption": "...", 
  "creditline": "...", 
  "renditions": [
    {
      "size": 1024, 
      "width": 1024, 
      "height": 656, 
      "mimetype": "image/jpeg", 
      "url": "https://...cloudfront.net/v3/image/resize/urn:...signature=..."
    }
    // more ...
]
}
],
\`\`\`

#### How can I select the image sizes from the entry?

About the list of **renditions** of an associated media object.

### APIs

#### For which scenario is which of the three interfaces best suited?

To help you decide which API fits best, we have created the following table.

<table border=1 cellspacing=0 cellpadding=10>
<tr>
  <th></th>
  <th>s3push-API</th>
  <th>wireQ-API</th>
  <th>jsonfeed-API</th>
</tr>
<tr>
  <td align=justify valign=top><strong>Scenario</strong></td>
  <td align=justify valign=top>event-based</td>
  <td align=justify valign=top>restful-queue</td>
  <td align=justify valign=top>restful</td>
</tr>
<tr>
  <td align=justify valign=top><strong>Differneces</strong></td>
  <td align=justify valign=top>The data is transferred to an S3 bucket provided by the customer.</td>
  <td align=justify valign=top>The client receives data from a cloud-based queue.</td>
  <td align=justify valign=top>A time-delayed (or rubric-based) aggregation that is regularly polled by the client.</td>
 </td>
</tr>
<tr>
  <td align=justify valign=top><strong>Advantages</strong></td>
  <td align=justify valign=top><ul><li>cloud- und eventbased</li><li>Low amount of data transferred (only new or updated articles)</li><li>simple connection of cloud-based applications</li></ul></td>
  <td align=justify valign=top><ul><li>restful-queue</li><li>Low amount of data transferred (only new or updated articles)</li><li>in the event of a failure of the importer, articles are reliably kept in the queue</li><li>simple restful interface</li></ul></td>
  <td align=justify valign=top><ul><li>simple restful interface</li></ul></td>
 </td>
</tr>
<tr>
  <td align=justify valign=top><strong>Disadvantages</strong></td>
  <td align=justify valign=top> - </td>
  <td align=justify valign=top><ul><li>no archive function</li><li>transmission-only view</li></ul></td>
  <td align=justify valign=top><ul><li>high transmitted data volumes</li><li>in the event of a prolonged failure of the importer, items may be lost</li><li>polling</li></ul></td>
 </td>
</tr>
</table>

#### I have been using the jsonfeed API so far, why should I migrate to the wireQ API?

Due to the buffering possibilities and the lower data volume, it makes a lot of
sense to migrate to the wireQ API.

The advantages of migration are as follows:
* Both APIs are simple restful interfaces.
* The amount of data transferred is less with the wireQ API than with the jsonfeed API, as only new or updated articles are retrieved.
* In the event of a failure of the importer, articles are reliably kept in the queue for several days.
* Both APIs return a list of entries \`entries: [ {...}, {...} ]\` in dpa-digitalwires format.
* The response \`POST /dequeue-entries.json\` is similar to that of the jsonfeed API.

Notes:
* The "simple method" with \`dequeue-entries\` requires reliable persistence of the topicles already received.
* Alternatively, a transactional receiving of the topicles can also be done in two steps: with \`GET entries.json\` and \`DELETE\`.

#### How can I perform a format conversion without deploying new software locally?

* Using s3push
* the lambda function implements the format conversion
* Lambda function is triggered by new incoming topicles
* hosting completely at AWS
* several options for transmission into the target system
 * Webhook
 * SQS, Eventbus etc.
* see also -> concrete scenarios and demo projects 

#### What is the average amount of data?

Each interface delivers the ordered content.
A jsonfeed of the dpa-InfolineRS is typically 1Mb in size.

#### I get an authentication error when retrieving the wireQ-API. What am I doing wrong?

The retrieval of the queue works via two methods
[see documentation](https://api-portal.dpa-newslab.com/doc/apis#comparison-wireq-api-with-jsonfeed-api):

The basic principle with the wireQ-API is that the receiver fetches entries with
\`GET {base-URL}/entries.json\` and then either remove it from the queue shortly
afterwards with \`DELETE {base-URL}​/entry/<receipt>\` (with the semantics
"reception confirmed") or use \`POST {base-URL}/​dequeue-entries.json\`
to execute the fetch and the deletion in one step.

After the entries have been picked up with \`GET {base-URL}/​entries.json\`, they
become invisible for a while, i.e. another \`GET {base-URL}/entries.json\`
shortly afterwards delivers other entries (the maximum number per response is
currently limited to 50) or none at all.

It is not sufficient to request just the base-URL stored in the API portal.
In this case, the error message appears: \`{"message":"Missing Authentication Token"}\`

This error message also occurs if you call the request
\`POST {base-URL}/dequeue-entries.json\` in the browser (which corresponds to a
GET-Request) instead of the console via:

\`\`\`bash 
curl -X POST {base-URL}/dequeue-entries.json
\`\`\`

### Import into CMS

#### How often should the wireQ API or the jsonfeed API be polled?

The following table provides an overview of the recommended poll intervals:

<table border=1 cellspacing=0 cellpadding=10>
<tr>
  <th></th>
  <th>Recommendation</th>
</tr>
<tr>
  <td valign=top><strong>wireQ-API<strong></td>
  <td align=justify valign=top>minimum every 30s, typically in the minute range</td>
</tr>
<tr>
  <td  valign=top><strong>jsonfeed-API without Conditional Request</strong></td>
  <td align=justify valign=top>every 5min (current content) or longer (service content) - 30min</td>
</tr>
<tr>
  <td valign=top><strong>jsonfeed-API with Conditional Request</strong></td>
  <td align=justify valign=top>1min - data volume better and speed - for not changed feeds no big response</td>
</tr>
</table>

#### How should the jsonfeed API be retrieved?

The jsonfeed API must be polled regularly, whereby the feed rarely changes within the poll interval.
To prevent unnecessary polling, we recommend implementing a "Conditional GET".
Here are two examples to illustrate the procedure:

##### Command line:

\`\`\`bash
curl -v -o /dev/null https://XXX.cloudfront.net/XXX/aufschaltung/au-XXX/feed/feed.json
-->
...ETag: "9e764579ab6a873563aa905217f6e061"

curl -v -o /dev/null -H 'If-None-Match: e809ce4015da9234d6cff180511d3a08' https://XXX.cloudfront.net/XXX/aufschaltung/au-XXX/feed/feed.json
--> HTTP/1.1 304 Not Modified
\`\`\`

##### Python example:

\`\`\`python
import requests
from time import sleep


def conditional_request(url):
  poll_interval = 30
  headers = {'Content-Type': 'application/json'}
  while True:
      try:
          response = requests.get(url, headers=headers)
      except Exception as e:
          raise e

      if response.status_code == 304:
          print('The feed has not been modified!')
      resp_headers = response.headers
      etag = resp_headers.get('ETag')
      if etag:
          headers['If-None-Match'] = etag

      sleep(poll_interval)


if __name__ == '__main__':
  url = 'https://XXX.cloudfront.net/XXX/aufschaltung/au-XXX/feed/feed.json'
  conditional_request(url)
\`\`\`

#### How often can I request an API and what data load does this generate?

After successfully setting up s3push (see <NavLink exact to="/api/s3push">API | s3push</NavLink>),
the new or updated topicles are automatically pushed directly into the S3 bucket.

The two restful APIs <NavLink exact to="/api/wireq">API | wireq</NavLink> and
<NavLink exact to="/api/jsonfeed">API | jsonfeed</NavLink> should be polled at regular intervals.

See also: [How often should the wireQ API or the jsonfeed API be polled?](#how-often-should-the-wireq-api-or-the-jsonfeed-api-be-polled)

#### How do I recognise blocking periods and how should I process them?

In the dpa-digitalwires format there is the key **embargoed**, which describes
the timestamp of a blocking period to be observed. The article may only be
published after this time stamp.

#### How do I recognise withdrawals and how should I process them?

In the dpa-digitalwires format there is the key **pubstatus**, which describes
the status of the publication. The following three values can be stored: "usable",
"withheld", "canceled". Only if the value is "usable" the article may be used.
Articles that have already been imported must be removed immediately.

#### How should I process the values "usable", "withheld" and "canceled" for the publication status?

For the key **pubstatus**, which describes the status of the publication, the
following three values can be stored: "usable", "withheld", "canceled".
Only if the value is "usable" the article may be used.
Articles that have already been imported must be removed immediately if the
status changes to "canceled".

The value "withheld" was included so that the description is compliant to NewsML-G2.
It is very unlikely that this value will ever exist in the weblines.
The idea behind the value (editorial speaking) is that an article with this
status may never be published - which means that this value changes to "usable".
An article that has the publication status "withheld" may be "canceled" or
"usable" in later versions.
In other words, related to the present, "canceled" and "withheld" are the same
thing - the content of the respective version may not be published.

Here is an excerpt from the
<a href="https://iptc.org/std/NewsML-G2/2.28/specification/NewsML-G2-2.28-specification.html#_processing_the_publish_status_of_an_item" target="_blank">NewsML-G2 documentation</a>:

> * stat:canceled (note U.S. spelling) means that the content of the newsItem must not be used, ever.
> * stat:withheld means the content must not be used until further notice.
> When an Item is cancelled, it must never be used, but an Item that has been withheld may subsequently
> have its status updated to “usable”. For further information on processing rules, see section 26.2

#### According to the documentation, the value "embargoed" represents a blocking period. It is not clear to me what this means for dealing with the articles. So far, the value has always been zero in my examples.

The key **embargoed** describes the time stamp of a blocking period to be observed.
An article for which the value is set may only be published after this time stamp.
This feature is rarely used by the editorial staff - therefore the value is usually null.

#### What do I have to do to display the Web Components on my website?

For handling the Web Components (these include, among others: \`<dnl-twitterembed>\`, \`<dnl-youtubeembed>\`,
\`<dnl-dwchart>\`) there are two possibilities:

1. Conversion in the editorial system: The Web Components can already be converted
 into your CMS / editorial system. We recommend this principle because the tweets
 that we embed are then no longer different from those that your editorial team
 inserts in articles, and possibly also your data protection mechanisms will
 take effect by default. For example, you can use the src attribute of a
 \`<dnl-twitterembed>\` component for this and convert it to an HTML Twitter
 embed according to your configuration preferences.

2. Converting in the browser or app: You can also pass the Web Components unchanged
 to your frontend, i.e. to the app or web page, and display the component and
 display the component there using the appropriate JavaScript code.
 For example, you can build on code that the dpa has published on
 <a href='https://github.com/dpa-newslab/dpa-digitalwires-embeds' target="_blank">github as
 open-soure</a> for this purpose.

There are a number of Web Components. More detailed information about individual
Web Components can be found <Navlink exact to="/doc/format">here</Navlink>.

### General

#### How can I implement special routing functionality without making major changes to my CMS?

Routing refers to the assignment of incoming articles to categories in the client's CMS.
For Webline articles, we recommend looking at the **categories** and routing them according to the **qcode**
of the rubrics (**dnltype:rubric**). Other metadata to route by if there is no metadata are: **subject** or **desk**.

For illustration purposes, a small excerpt from the dpa-digitalwires format:

\`\`\`
"categories": [
      {
        "type": "dnltype:rubric",
        "name": "weblines.infoline_rs.topthemen.hintergruende",
        "qcode": "dnlpath:weblines.infoline_rs.topthemen.hintergruende",
        "is_current": true
      },
      {
        "type": "dnltype:dpasubject",
        "name": "Landtag",
        "qcode": "dpasubject:590",
        "rank": 1
      },
      {
        "type": "dnltype:dpasubject",
        "name": "Regierung",
        "qcode": "dpasubject:594",
        "rank": 2
      },
      {
        "type": "dnltype:desk",
        "name": "pl",
        "qcode": "dpacat:pl"
      },
...
]
\`\`\`

Alternatively, it can be routed according to **dnltype:wire**.
For illustration purposes, a small excerpt from the dpa-digitalwires format:

\`\`\`
"categories": [
      {
        "type": "dnltype:wire",
        "name": "basisdienst",
        "qcode": "dpasrv:bdt"
      },
...
]
\`\`\`

We recommend implementing the routing using s3push. When a new or updated topicle
is received, a lambda function can be triggered that implements the routing functionality.

#### What can I do if I want to use s3push with webhook, but my CMS is behind a firewall?

We assume the following scenario:
* s3push is used
* A lambda function is bound to update events of the s3 bucket.
* The Lambda function executes a POST request for each new incoming topicle to an internal CMS.

For requests originating from AWS Lambda functions (without VPC), no unique and
constant source IP addresses can be defined. Therefore, the destination port for
the CMS import must be opened for all source addresses. 
In some cases, this procedure is not desirable for reasons of network security.

If this is the case, the following solution is possible:

* In addition, a queue (SQS) is defined in which topicles are enqueued.
* The SQS queue is regularly queried (by long polling) via an import process in the internal network of the CMS.
* In this case, only network requests are made from the inside to the outside, so there should be fewer problems with the definition of a firewall.

For this purpose, there is an example project that can be used to easily deploy
the required resources (S3 bucket, Lambda function, SQS). If you are interested,
please do not hesitate to contact us!

#### Which address information do the dpa feeds provide?

Address information can be found in the categorical metadata of the type **poi**.

For illustration purposes, a small excerpt from the dpa-digitalwires format:

\`\`\`
"categories": [
{
  "type": "dnltype:poi",
  "name": "Bundestag, Platz der Republik 1, 11011 Berlin, Deutschland",
  "qcode": null,
  "geojson": {
    "type": "Feature",
    "properties": {
      "name": "Bundestag",
      "formatted_address": "Platz der Republik 1, 11011 Berlin, Deutschland",
      "locality": "Berlin",
      "administrative_area_level_1": "Berlin",
      "country": "Deutschland"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        13.3756895,
        52.5182798
      ]
    }
  }
},
// next category...
]
\`\`\`
`

export { faq }


// WEBPACK FOOTER //
// ./src/all_cards/docu/faq_en.js